var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dx-modal',{attrs:{"title":"Solicitantes / Indicações","value":_vm.show,"size":"lg","id":"modal-referral-manager"},on:{"input":_vm.close}},[_c('referral-list',{on:{"changed":function($event){_vm.changed = true}}}),_c('template',{slot:"footer"},[_c('button',{staticClass:"btn",on:{"click":_vm.close}},[_vm._v("Sair")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }